import DC from "../../common/DataConnector";
import { i18n } from '../../lang/i18n';
import { actAlertShow, actCartProductQuantityChange, actLoading, actLoadingEnd } from "../../store/Actions";
import HelperProducts from "../../common/HelperProducts";
import UserLoginScreen from "../Customer/Login/UserLoginScreen";
import { NavLink, useNavigate } from "react-router-dom";
import PayWithGoogle from "./PayWithGoogle";
import PayWithCardRedsys from "./PayWithCardRedsys";
import { ordersLoad } from "../../store/UserData/UserData";
import CheckboxSwitch from "../../components/CheckboxSwitchComponent/CheckboxSwitch";
import Helpers from "../../common/Helpers";
import ScrollToTop from "../../components/ScrollToTop";
import { reducerCartClear, reducerCartRitmitoUpdate } from '../../store/Cart/CartReducer';
import { PaymentTypes } from '../../common/Enums';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export default function TabCart()
{
    const dispatch = useAppDispatch()
    const cart = useAppSelector((state) => state.cart)
    const userData = useAppSelector((state) => state.userData)
    const schedule = useAppSelector((state) => state.appData.schedule)
    const productExtras = useAppSelector((state) => state.appData.productExtras)
    const navigate = useNavigate();
    const ritmitosAvailable = calculateRitmitosAvailables();

    function calculateRitmitosAvailables(){
        if(userData?.loyalty)
            return userData.loyalty.ritmitosAvailable - (userData.loyalty.ritmitosInOrders??0);
        return 0;
    }

    function onClearClick(e: any)
    {
        e.preventDefault();
        dispatch(reducerCartClear());
        navigate('/')
    }

    function cartToList(data: any)
    {
        let items = [];
        for (let f in data) {
            items.push(data[f]);
        }
        return items;
    }

    async function onGetRedsysData(paymentTypeId: number)
    {
        return generateOrderStart(paymentTypeId);
    }

    async function onGooglePayOk(paymentRequest: any)
    {
        navigate('/pok')
        await generateOrderStart(PaymentTypes.GooglePay, JSON.stringify(paymentRequest))
        await ordersLoad(dispatch)
    }

    async function generateOrderStart(paymentTypeId: number, paymentInfo: string = '')
    {
        actLoading(dispatch)
        let ps: any = [];
        let postData = {
            paymentType: { id: paymentTypeId },
            products: ps,
            totalProducts: cart.products.length,
            totalPrice: cart.totalPrice.toFixed(2),
            totalPriceVat: cart.totalVat.toFixed(2),
            paymentInfo: paymentInfo
        }

        const products = cart.products;
        for (let x = 0; x < products.length; x++) {
            postData.products.push({
                code: products[x].product.productCode,
                quantity: products[x].quantity,
                priceBase: products[x].priceBase,
                price: products[x].product.price,
                priceVat: products[x].product.priceVat,
                vatTypeId: products[x].product.vatType.id,
                title: products[x].product.title,
                discount: products[x].discount,
                preferences: products[x].preferences.filter(function (el: any) { return el.value; }),
                useRitmitos: products[x].useRitmitos
            });
        }

        let content = await DC.PostData('/customer/orders', postData);
        if (content.wasOk) {
            dispatch(reducerCartClear());
            return content.data;
        } else {
            actAlertShow(dispatch, 'warning', i18n.Errors.ErrorSavingData);
        }
        actLoadingEnd(dispatch)
    }

    function onItemChange(index: number, value: number)
    {
        if (value === -1 && cart.products.length === 1 && cart.products[0].quantity === 1)
            navigate('/')
            actCartProductQuantityChange(dispatch,index, value)
    }

    function renderNoProducts()
    {
        return (<div className="view-cart">
            <div className="main-subtitle">
                <h3>{i18n.ViewCart.CartTitle}</h3>
            </div>
            <div className="box text-center pt-5 pb-5"><p>{i18n.ViewCart.NoProducts}</p></div>
            <div className="box">
                <br />
                <div className="container main-subtitle mt-1">
                    <NavLink to="/" className="btn-back link-btn"> <i className="fa fa-home" />{i18n._Labels.SeeProducts}</NavLink>
                </div>
                <br />
            </div>
        </div>)
    }

    function renderProducts(products: any[])
    {
        return (<div className="box text-right">
            <table className="table">
                <tbody>
                    {products.map((item, index) => (
                        <tr key={index} className="product-row">
                            <td className="step-number"><img src={item.product.photo.url250} alt={item.product.title} /></td>
                            <td className="text-left">
                                {HelperProducts.ProductDescription(productExtras, item)}
                                <div className="size-buttons">
                                    <button type="button" className="btn btn-sm" data-action="minus"
                                        data-code={item.key}
                                        onClick={() => onItemChange(index, -1)}><i
                                            className="fa fa-minus" /></button>
                                    <label
                                        className="size-quantity">{item.quantity}</label>
                                    <button type="button" className="btn btn-sm" data-action="plus"
                                        data-code={item.key}
                                        onClick={() => onItemChange(index, 1)}><i className="fa fa-plus" />
                                    </button>
                                </div>
                            </td>
                            <td className="price">{item.price.toFixed(2)}€</td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan={4}>
                            <button type="button" className="btn btn-outline-secondary btn-sm btn-delete"
                                onClick={onClearClick}>
                                <i className="fa fa-trash-alt" />
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} className="price">{i18n.TabCart.ListTotal}: {cart.totalPrice.toFixed ? cart.totalPrice.toFixed(2) : cart.totalPrice} €</td>
                    </tr>
                </tbody>
            </table>
        </div>)
    }

    function minutes(products: any[]): string
    {
        let minutes = products.length * 3;
        if (minutes < 3) minutes = 5;
        if (minutes > 15) minutes = 15;
        return minutes.toString();
    }

    if (cart.totalProducts === 0)
        return renderNoProducts()

    const products = cartToList(cart.products);

    function renderWithLogin()
    {
        if (!userData.isActive) return null
        return <>
            <div className="box p-3">
                <div className="row">
                    <div className="col-12 text-center"><h4>{i18n.TabCart.Subtitle}</h4></div>
                    <br />
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <p>{i18n.TabCart.PaymentCashDes}</p>
                    </div>
                    <div className="col-12">
                        <p><b>{i18n.TabCart.PaymentImportant.replace('{minutes}', minutes(products))}</b></p>
                    </div>
                </div>
            </div>
            <div className="box p-3 text-center">
                <PayWithCardRedsys onGetRedsysData={onGetRedsysData} totalPrice={cart.totalPrice} title={i18n.TabCart.BuyAndPickUpInStore} style={{ maxWidth: '80%' }} />
            </div>
            <div className="box p-3 text-center">
                <PayWithGoogle onPaymentOk={onGooglePayOk} totalPrice={cart.totalPrice} />
            </div>
        </>
    }
    function renderWithoutLogin()
    {

        if (!Helpers.ScheduleIsOpen(schedule))
            return <div className="box p-3 text-center">
                <p>{i18n.TabCart.WeAreClosed}</p>
            </div>;
        return <div className="tab-cart">
            <div className="tab-cart-body">
                <div className="main-subtitle">
                    <h3>{i18n.TabCart.LetRegisterFirst}</h3>
                </div>
                <div>
                    <div className="">
                        <p>{i18n.TabCart.LetRegisterFirst_Line1}</p>
                        <p>{i18n.TabCart.LetRegisterFirst_Line2}</p>
                    </div>
                    <UserLoginScreen />
                </div>
            </div>
        </div>
    }

    if (!userData.isActive)
        return renderWithoutLogin()

    return (<div className="tab-cart">
        <ScrollToTop />
        <div className="tab-cart-body">
            <div className="main-subtitle">
                <h3>{i18n.TabCart.Title}</h3>
                <div style={{ color: 'black' }}>
                    <h5>{i18n.TabCart.YouHave} {ritmitosAvailable}⚡</h5>
                    <CheckboxSwitch conf={{ active: cart.useRitmitos, textActive: i18n.TabCart.RitmitosUse, textDeactivate: i18n.TabCart.RitmitosNotUse, fieldName: '' }}
                        style={{ display: 'inline' }}
                        onChange={(e: any, conf: any) =>
                        {
                            dispatch(reducerCartRitmitoUpdate({ useRitmitos: conf.active, ritmitosAvailable: ritmitosAvailable }))
                            return true;
                        }}
                    />
                </div>
            </div>
            {renderProducts(products)}
            {renderWithLogin()}
        </div>
        <br /><br />
    </div>
    )
}
